import React from "react";
import "./style.scss";

interface ButtonProps {
    children?: any;
    kind?: "primary" | "secondary" | "tertiary";
    size?: "standard" | "medium" | "large";
    light?: boolean;
    alert?: boolean;
    square?: boolean;
    disabled?: boolean;
    width?: number | string;
    onClick?: () => void;
}

const Button = (props: ButtonProps) => {
    const onButtonClick = () => {
        if (props.onClick) {
            props.onClick();
        }
    };

    return (
        <button
            {...props}
            style={{ width: props.width || "" }}
            className={`vapor_btn vapor_btn-${props.kind} vapor_btn-${props.size} 
        ${props.disabled ? "vapor_btn-disabled" : ""} ${props.light ? "vapor_btn-light" : ""}`}
            onClick={() => onButtonClick()}
        >
            {props.children}
        </button>
    );
};

Button.defaultProps = {
    size: "standard",
    kind: "primary",
    alert: false,
    square: false,
    disabled: false,
};

export default Button;
